export default __webpack_public_path__ + "static/HarmoniaSansProCyr-Bold-eb2d17067a00bd54e6ed4f5087227b5a.woff2";